export enum SearchStatus {
    Started = 'started',
    InProgress = 'inProgress',
    Finished = 'finished',
    Gotten = 'gotten',
  }
  